var React = require('react');

function GradientUser (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18 18C22.1421 18 25.5 14.6421 25.5 10.5C25.5 6.35786 22.1421 3 18 3C13.8579 3 10.5 6.35786 10.5 10.5C10.5 14.6421 13.8579 18 18 18Z","stroke":"#247E7A","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M30.885 33C30.885 27.195 25.11 22.5 18 22.5C10.89 22.5 5.11499 27.195 5.11499 33","stroke":"#247E7A","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

GradientUser.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = GradientUser;

GradientUser.default = GradientUser;
